import { useState } from "react";
import {
  Card, CardActions, CardContent, CardMedia, Typography,
  IconButton, Box, Chip, TextField, Button,
  Dialog, DialogTitle, DialogContent, DialogActions
} from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
import VisibilityIcon from "@mui/icons-material/Visibility";

const FeedCard = ({ publication, onEdit, onDelete, onToggleHidden, setOpenForm, setEditingId }) => {
  const [isEditing, setIsEditing] = useState(false);
  const [editData, setEditData] = useState({ ...publication });

  // Modal de confirmación
  const [openConfirm, setOpenConfirm] = useState(false);
  // Valor objetivo al que queremos cambiar (true/false). NO usamos `hidden` directamente.
  const [pendingHidden, setPendingHidden] = useState(null); // null | boolean

  const {
    id,
    thumbnail,
    redirectlink,
    description,
    order,
    hidden,       // <- estado actual (desde editData)
    createdAt,
    note,
  } = editData;

  // Abrir confirm y “congelar” la intención
  const openConfirmToggle = () => {
    setPendingHidden(!hidden); // lo que queremos que quede
    setOpenConfirm(true);
  };

  const closeConfirmToggle = () => {
    setOpenConfirm(false);
    setPendingHidden(null);
  };

  const confirmToggle = async () => {
    const next = pendingHidden ?? !hidden;

    // ✅ Update optimista del icono ANTES de cerrar (o justo después de cerrar si preferís)
    setEditData((prev) => ({ ...prev, hidden: next }));

    // Llamar al padre para sincronizar con el back
    await onToggleHidden(id, next);

    // Cerrar y limpiar
    setOpenConfirm(false);
    setPendingHidden(null);
  };

  return (
    <>
      <Card sx={{ maxWidth: 345, boxShadow: 3, position: "relative" }}>
        <CardMedia component="img" height="180" image={thumbnail} alt={description} />

        {hidden && (
          <Chip
            icon={<VisibilityOffIcon />}
            label="Oculto"
            color="warning"
            size="small"
            sx={{ position: "absolute", top: 8, left: 8 }}
          />
        )}

        <CardContent>

          <>
            <Typography gutterBottom variant="body2">
              Orden: {order}
            </Typography>
            <Typography variant="body2" color="text.secondary">
              {description || "descripcion"}
            </Typography>
            <Typography variant="body2" color="text.secondary">
              {note || "subtitulo"}
            </Typography>
            <Typography
              variant="body2"
              color="primary"
              component="a"
              href={redirectlink}
              target="_blank"
              rel="noopener noreferrer"
            >
              {redirectlink}
            </Typography>
            <Typography variant="caption" color="text.secondary" display="block" mt={1}>
              Creado: {new Date(createdAt).toLocaleDateString()}
            </Typography>
          </>
        </CardContent>

        <CardActions sx={{ justifyContent: "space-between" }}>
          <Box>

            <IconButton color="primary"
              onClick={() => {
                setIsEditing(true);
                setOpenForm(true);
                onEdit(publication);
              }}      >
              <EditIcon />
            </IconButton>

            <IconButton
              color={hidden ? "warning" : "default"}
              onClick={openConfirmToggle}
            >
              {hidden ? <VisibilityIcon color="primary" /> : <VisibilityOffIcon color="disabled" />}
            </IconButton>

            <IconButton color="error" onClick={() => onDelete(id)}>
              <DeleteIcon />
            </IconButton>
          </Box>
        </CardActions>
      </Card >

      {/* Modal de confirmación usando `pendingHidden` */}
      < Dialog open={openConfirm} onClose={closeConfirmToggle} >
        <DialogTitle>
          {hidden ? "Mostrar publicación" : "Ocultar publicación"}
        </DialogTitle>
        <DialogContent>
          <Typography variant="body2">
            {hidden
              ? "¿Querés volver a mostrar esta publicación?"
              : "¿Querés ocultar esta publicación?"}
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button onClick={closeConfirmToggle}>Cancelar</Button>
          <Button variant="contained" onClick={confirmToggle}>Aceptar</Button>
        </DialogActions>
      </Dialog >
    </>
  );
};

export default FeedCard;
